module.exports = {
	"trackingId": "UA-45029200-1"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/googleAnalytics.credentials.json
// module id = 1409
// module chunks = 0